import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-left\"><path d=\"M5.89 3.864c.003 0 .353-.353 0-.707-.354-.353-.708 0-.708 0L1 7.5l4.182 4.021s.354.354.708 0c.353-.353-.004-.707 0-.707L2.913 8H13.5s.5 0 .5-.5-.5-.5-.5-.5H2.914L5.89 3.864z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol